import { login, changePassword } from "./authentication";
import { getNurseries, getNursery, getNurseryStats } from "./nurseries";
import { getTanks, getTank, getTankStats } from "./tanks";
import { getRacks, getRack, uploadRackImage, getRackOutplantingPrediction } from "./racks";
import { getRackObservations, getObservation, createRackObservation, updateRackObservation, deleteObservation, getObservationDates, getObservationStats } from "./observations";
import { countFragments } from "./count-fragments";

export default {
  login,
  changePassword,
  getNurseries,
  getNursery,
  getNurseryStats,
  getTanks,
  getTank,
  getTankStats,
  getRacks,
  getRack,
  getRackOutplantingPrediction,
  createRackObservation,
  updateRackObservation,
  getRackObservations,
  getObservation,
  getObservationStats,
  getObservationDates,
  deleteObservation,
  uploadRackImage,
  countFragments
};
